<template>
  <form class=" mt-2" id="user_create_form" @submit.prevent="save_user">

    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">First Name<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="user.first_name" placeholder="First Name" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Last Name<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="user.last_name" placeholder="Last Name" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Username<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="user.user_name" placeholder="Username" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Email<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="user.email" placeholder="Email" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Password<span style="color: red">*</span>:</label>
          <input type="password" class="form-control" v-model="user.password" placeholder="Password" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Phone:</label>
          <input type="text" class="form-control" v-model="user.phone" placeholder="Phone" />
        </div>
      </div>
    </div>
    <div class='row'>
      <div class="col-md-12">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Organizations<span style="color: red">*</span>:</label>
          <multiselect :options="orgList.map(organization => organization.organization_id)"
            v-model="user.organizations" :loading="is_loading_organizations" placeholder="Select Organizations"
            :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
            :multiple="true" :close-on-select="false" :preserve-search="true"
            :custom-label="opt => orgList.find(x => x.organization_id == opt).name" />
          <!-- @search-change="searchCategories" -->
        </div>
      </div>
    </div>
    <diV class="row">
      <div class="col-md-12">
        <!-- buttons -->
        <div class="form-footer text-right">
          <button type="button" class="btn btn-secondary btn-sm" v-on:click="close_modal()">Close</button>
          <button type="submit" class="btn btn-primary btn-sm ml-1">Save</button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Multiselect from 'vue-multiselect';
  // import { CustomValidation } from "@/custom_validation.js";
  import axios from 'axios';
  import {hasPermission} from "@/utils/permissions";

  export default {
    components: {
      Multiselect
    },
    props: [
      'module_id', 'formData'
    ],
    // mixins: [CustomValidation],
    data: function () {
      return {
        user: this.get_empty_user_obj(),
        is_loading_organizations: false,
        orgList: []
      };
    },
    computed: {
      organizations_list: function () {
        return this.$store.getters['organizations/organizations']
      }
    },
    beforeCreate: function () {
      // let loader = this.$loading.show({
      //   loader: 'dots',
      //   container: this.fullPage ? null : this.$refs.formContainer,
      // });
      // this.$store.dispatch('organizations/get_all_organizations', [1, 2]).then(() => {
      //   loader.hide();
      // });
    },
    created: function () {
      if (this.formData != undefined) {
        this.$store.dispatch('users/get_master_user', [this.formData]).then(() => {
          this.user = this.$store.getters['users/user'];
        });
      }
      this.getOrganizations();
    },
    watch: {
      formData: {
        handler(newFormData) {
          if (newFormData != undefined) {
            this.$store.dispatch('users/get_master_user', [newFormData]).then(() => {
              this.user = this.$store.getters['users/user'];
            });
          } else {
            // Reset to empty user object when formData is undefined (new user)
            this.user = this.get_empty_user_obj();
          }
        },
        immediate: false
      }
    },
    methods: {
      save_user() {
        let errors = false;
        if (this.user.user_name == '' || this.user.user_name == undefined || this.user.first_name== '' || this.user.last_name=='') {
          errors = true;
        }
        if ((this.formData != undefined && this.user.password == '')||(this.formData != undefined && this.user.password == undefined) || this.user.organizations.length == 0 ) {
          errors = true;
        }
        if (errors == true) {
          this.$toast.warning('Please fill requireds fields');
        } else {
          let update_method = '/admin/users/create-user';
          let permission = {};
          permission = {
            headers: {
              'X-Permission': 'master_users_create'
            }
          };
          if (this.formData != undefined) {
            update_method = '/admin/users/update_user';
          }

          axios.post(update_method, this.user,permission)
            .then((response) => {
              this.user = this.get_empty_user_obj();
              if(response.data.error){
                if(response.data.error.errorInfo[1] == 1062){
                  this.$toast.error("Username Already Exists");
                }else{
                  this.$toast.error("OOPS! something went wrong");
                }

              }else{
                this.$toast.success(response.data.message);
                this.user = this.get_empty_user_obj();
                // this.close_modal();
                 let loader = this.$loading.show({
                  loader: "dots",
                  container: this.fullPage ? null : this.$refs.formContainer,
                });
                  this.$store.dispatch('users/get_master_users_list', [1, 'all']).then(function () {
                    loader.hide();
                  });
                  window.$('#modal').modal('hide')
                  // this.$store.dispatch('user
              }
              //  window.location.reload();
              // window.$('#modal').modal('hide');
            });
        }
      },
      get_empty_user_obj() {
        return { user_name: '', password: '', first_name: '', last_name: '', organizations: [], email: '', phone: '', role_id: 1 };
      },
      close_modal() {
        this.$store.dispatch('modal/close', {});
      },
      getOrganizations(){
          const permission = {
            headers: {
              'X-Permission': 'all_organization_list'
            }
          };
          axios.get('/admin/users/get-all-organizations',permission)
              .then((response) => {
                this.orgList = response.data;
              });
      },
    }

  }
</script>

<style scoped>
  span.error {
    display: block;
    color: red;
    margin-top: 5px;
  }

  .field {
    margin-top: 20px;
  }
</style>